import React, {
  Fragment,
  useState,
  useCallback,
  useMemo,
  useEffect,
} from "react";
import differenceBy from "lodash/differenceBy";
import { Trash2, Edit, Plus, Download, Eye, Printer } from "react-feather";
import { toast } from "react-toastify";
import { useTranslation } from 'react-i18next';
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Badge,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Label,
  Toast,
} from "reactstrap";
import SingleSelect from "../../SingleSelect/SingleSelect";
import { Btn, H5 } from "../../../AbstractElements";
import axios from "axios";
import CustomPopup from '../../../_core/Ui-kits/Tooltip/Basic2'

const FilterComponent = ({ filterText, onFilter, onClear, t }) => (
  <>
    <input
      className="form-control"
      placeholder={t("Filter by Name")}
      aria-label="Search Input"
      style={{ width: "250px", paddingLeft: "5px" }}
      name="phone"
      id="search"
      type="text"
      value={filterText}
      onChange={onFilter}
    />
    <Btn attrBtn={{ onClick: onClear }} type="button">
      X
    </Btn>
  </>
);

const DataTablesContain = () => {
  const token = localStorage?.getItem("token");
  const [data, setData] = useState();
  const { t } = useTranslation();
  const [user_id, setUserId] = useState();
  const [currentStart, setCurrentStart] = useState('');
  const [currentEnd, setCurrentEnd] = useState('');
  const pres = localStorage.getItem("pres");
  const [modal, setModal] = useState(false);
  const [userOption, setSelectedUserOption] = useState("Member");
  const toggle = (e) => {
    e.preventDefault();
    setModal(!modal);
  };
  const [filteredItems, setFilteredItems] = useState();
  useEffect(() => {
    handle_get_firms();
    handle_get_dates();
  }, []);

  const user_options = ["NADA Office", "President", "Member"];

  const handle_get_firms = async () => {
    try {
      const response2 = await axios.get(
        "https://api-portal.nada.org.np/api/proxies",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response2?.data?.success) {
        setData(response2?.data?.data?.proxies);
        setFilteredItems(response2?.data?.data?.proxies);
      }
    } catch (error) {
      if (error.response) {
        console.error("Error response:", error.response);
        toast.error(error?.response?.data?.message || "An error occurred");
      } else if (error?.request) {
        console.error("Error request:", error?.request);
        toast.error("No response received from server");
      } else {
        console.error("Error message:", error?.message);
        toast.error(error?.message);
      }
    }
  };

  const handle_get_dates = async () => {
    try {
      const response2 = await axios.get("https://api-portal.nada.org.np/api/proxies/proxy/dates", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response2?.data?.success) {
        setCurrentStart(response2?.data?.data?.dates?.[0]?.start_date);
        setCurrentEnd(response2?.data?.data?.dates?.[0]?.end_date);
      }
    } catch (error) {
      if (error.response) {
        console.error("Error response:", error.response);
        toast.error(error?.response?.data?.message || "An error occurred");
      } else if (error?.request) {
        console.error("Error request:", error?.request);
        toast.error("No response received from server");
      } else {
        console.error("Error message:", error?.message);
        toast.error(error?.message);
      }
    }
  };

  const navigate = useNavigate();
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);

  const contextActions = useMemo(() => {
    const handleDelete = () => {
      if (
        window.confirm(
          `Are you sure you want to delete:\r ${selectedRows.map(
            (r) => r.name
          )}?`
        )
      ) {
        setToggleCleared(!toggleCleared);
        setData(differenceBy(data, selectedRows, "name"));
        toast.success("Successfully Deleted !");
      }
    };

    return (
      <Btn attrBtn={{ color: "danger", onClick: handleDelete }} key="delete">
        Delete
      </Btn>
    );
  }, [data, selectedRows, toggleCleared]);

  const handleDelete = () => {
    if (
      window.confirm(
        `Are you sure you want to delete:\r ${selectedRows.map((r) => r.name)}?`
      )
    ) {
      setToggleCleared(!toggleCleared);
      setData(differenceBy(data, selectedRows, "name"));
      toast.success("Successfully Deleted !");
    }
  };

  /*const handlePrint = (imageUrl, e) => {
    e.preventDefault();
    var link = "https://d24xzirvx50zjt.cloudfront.net/" + imageUrl;
    const printWindow = window.open('', '_blank');
    printWindow.document.open();
    printWindow.document.write(`
        <html>
            <head>
                <title>Print Image</title>
                <style>
                    body { margin: 0; display: flex; justify-content: center; align-items: center; }
                    img { max-width: 100%; height: auto; }
                </style>
            </head>
            <body onload="window.print(); window.close();">
                <img src="${link}" alt="Printable Image" />
            </body>
        </html>
    `);
    printWindow.document.close();
};*/


const handlePrint = (pdfUrl, e) => {
  e.preventDefault();
  const printWindow = window.open('', '_blank');
  printWindow.document.write(`
    <html>
      <head>
        <title>Print PDF</title>
        <style>
          body {
            margin: 0;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          iframe {
            width: 100%;
            height: 100vh;
            border: none;
          }
        </style>
      </head>
      <body onload="window.print(); window.close();">
        <iframe src="${pdfUrl}"></iframe>
      </body>
    </html>
  `);
  printWindow.document.close();
};


// Function to download the image
const handleDownload = async (imageUrl, e) => {
  e.preventDefault();
    try {
      var link = "https://d24xzirvx50zjt.cloudfront.net/" + imageUrl;
        const response = await fetch(link);
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = link.split('/').pop() || 'image.png'; // Extract file name from URL
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url); // Clean up the object URL
    } catch (error) {
        console.error('Error downloading image:', error);
    }
};

  const handleClick = (link, e) => {
    e.preventDefault();
    window.open(link, "_blank", "noopener,noreferrer");
  };

  function ComponentEdit({ row }) {
    return (
      <span style={{ display: "flex", flexDirection: "row", gap: 15, cursor: 'pointer' }}>

        <div
          onClick={() => {
            navigate("/proxy/edit", { state: { id: row?.id } });
          }}
        >
          <Edit />
        </div>
        {row?.status === 3?
          <>
            <div
          onClick={(e) => {
            handleClick(row?.proxy_doc, e);
          }}
        >
          <Eye />
        </div>
        <div
          onClick={(e) => {
            handleClick(row?.proxy_doc, e);
          }}
        >
          <Printer />
        </div>
        <div
          onClick={(e) => {
            handleClick(row?.proxy_doc, e);
          }}
        >
          <Download />
        </div>
          </>
          : null
        }

        {/*<div onClick={(e) => handleDelete(row?.id, e)}>
        <Trash2 color="#e52727" />
      </div>*/}
      </span>
    );
  }

  const handleAddNewClick = () => {
    navigate("/proxy/add");
  };

  const renderStatusBadge = (status) => {
    switch (status) {
      case 1:
        return <Badge color="primary">Submitted</Badge>;
      case 2:
        return <Badge color="secondary">Send For Edits</Badge>;
      case 3:
        return <Badge color="success">Accepted</Badge>;
      case 4:
        return <Badge color="danger">Rejected</Badge>;
      default:
        return <Badge color="warning">Submitted</Badge>;
    }
  };

  const customStyles = {
    headCells: {
      style: {
        height: "80px",
        fontSize: "20px", // Change font size
        fontWeight: "bold", // Make it bold
        color: "#333", // Optional: Change text color
        backgroundColor: "#f5f5f5", // Optional: Change background color
      },
    },
  };

  const tableColumns = [
    {
      name: t("ID"),
      selector: (Row) => Row["id"],
      sortable: true,
      center: true,
    },
    {
      name: t("Name of Firm"),
      selector: (Row) => Row["name_of_organization"],
      sortable: true,
      center: true,
    },
    {
      name: t("Proxy UID"),
      selector: (Row) => Row["uid"],
      sortable: true,
      center: true,
    },
    {
      name: t("Status"),
      selector: (Row) => renderStatusBadge(Row["status"]),
      sortable: true,
      center: true,
    },
 { name: t("Actions"), cell: (row) => <ComponentEdit row={row} /> }
  ];

  const handleRowSelected = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  const subHeaderComponentMemo = React.useMemo(() => {
    if (filterText === "") {
      setFilteredItems(data);
    } else {
      setFilteredItems(
        data?.filter((item) =>
          item?.name?.toLowerCase()?.includes(filterText?.toLowerCase())
        )
      );
    }

    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
        t={t}
      />
    );
  }, [filterText, resetPaginationToggle]);

  const handle_user_update = async (e) => {
    e.preventDefault();
    if (user_id) {
      try {
        const response2 = await axios.post(
          "https://api-portal.nada.org.np/api/users/status",
          {
            admin:
              userOption === "NADA Office" || userOption === "President"
                ? true
                : false,
            pres: userOption === "President" ? true : false,
            id: user_id,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response2?.data?.success) {
          toast.success(response2?.data?.message);
          setModal(!modal);
        }
      } catch (error) {
        if (error.response) {
          console.error("Error response:", error.response);
          toast.error(error.response.data.message || "An error occurred");
        } else if (error.request) {
          console.error("Error request:", error.request);
          toast.error("No response received from server");
        } else {
          console.error("Error message:", error.message);
          toast.error(error.message);
        }
      }
    }
  };

  const isDateInRange = (current, start, end) => {
    console.log('dates', current, start, end )
    return current >= start && current <= end;
  };

  const handleAdd = () => {
    var currentDate = new Date();
    var startDate = new Date(currentStart);
    var endDate = new Date(currentEnd);

    if(isDateInRange(currentDate, startDate, endDate)) {
      handleAddNewClick()
    } else {
      toast.error('Please revist when proxy date is announced');
    }
  };

  return (
    <Fragment>
      <Container fluid={true} className="data-tables">
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader
                className="pb-0"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <H5>{t("Proxies")}</H5>

                  <Btn
                    attrBtn={{
                      color: "primary",
                      onClick:  handleAdd
                     }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {t("Add New")}
                  </Btn>
              </CardHeader>
              <CardBody>
                {data && (
                  <DataTable
                    data={filteredItems}
                    columns={tableColumns}
                    striped={true}
                    center={true}
                    persistTableHead
                    subHeader
                    selectableRows
                    subHeaderComponent={subHeaderComponentMemo}
                    paginationResetDefaultPage={resetPaginationToggle}
                    onSelectedRowsChange={handleRowSelected}
                    clearSelectedRows={toggleCleared}
                    pagination
                    customStyles={customStyles}
                  />
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <Modal
        isOpen={modal}
        toggle={toggle}
        //size={props.size}
        centered
      >
        <ModalHeader toggle={toggle}>Update User Role</ModalHeader>
        <ModalBody
        //className={props.bodyClass}
        >
          <SingleSelect
            options={user_options}
            selectedOption={userOption}
            onChange={setSelectedUserOption}
          />
        </ModalBody>
        <ModalFooter>
          <Btn attrBtn={{ color: "secondary", onClick: toggle, height: 65 }}>
            Close
          </Btn>
          <Btn
            attrBtn={{
              color: "primary",
              onClick: (e) => handle_user_update(e),
              outerHeight: 65,
            }}
          >
            Update
          </Btn>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};
export default DataTablesContain;
